<template>
    <div class="section-text" :class="{rtl:this.$store.state.rtl}">
        <div class="section-text__content" v-html="seoText"></div>
    </div>
</template>

<script>
export default {
    name: "SeoTextBlock",

    props: ['componentContent'],

    computed: {
        seoText() {
            return this.componentContent && this.componentContent.seoText;
        },
    },
}
</script>

<style lang="sass" scoped>
@import "sass/components/pages/parts/contents/SeoTextBlock"
</style>